import classNames from 'classnames'
import React, { useCallback } from 'react'
import { mainHeadingId } from 'App'
import { Button } from 'components/Button/Button'
import { IconPrint } from 'components/Icon/IconPrint'
import { useTranslation } from 'react-i18next'
import { SiteActivityComponent } from '@cms-max/cms-browser-api-client'

export interface IContentLayoutProps {
  heading: string
  description?: React.ReactNode
  children?: React.ReactNode
  className?: string
  width?: 'wide' | 'default'
  withPrintButton?: boolean
  printComponent?: SiteActivityComponent
  // TODO: Rename this to something other than nav, since it could be anything --- but for our use cases it will always be a nav
  /** A nav that appears above the content heading. This should be an element wrapped in an html nav component */
  nav?: React.ReactNode
}

export const ContentLayout: React.FC<IContentLayoutProps> = (props) => {
  const {
    heading,
    description,
    children,
    className,
    width = 'default',
    withPrintButton,
    printComponent,
    nav
  } = props

  const { t } = useTranslation('common')

  const WithPrintButton = useCallback(() => {
    const handlePrint: React.MouseEventHandler<HTMLButtonElement> = (e) => {
      e.preventDefault()
      window.print()
    }

    if (!printComponent) {
      return (
        <Button
          className="ds-c-button ds-u-border--0 my-u-no-hover my-u-p--0"
          onClick={handlePrint}
        >
          <span className="ds-u-display--flex ds-u-flex-direction--column ds-u-justify-content--center">
            <IconPrint className="ds-u-color--base" aria-hidden />
            <span className="my-u-m--0 ds-u-font-size--sm ds-u-text-decoration--none">
              {t('print')}
            </span>
          </span>
        </Button>
      )
    } else {
      return (
        <Button
          className="ds-c-button ds-u-border--0 my-u-no-hover my-u-p--0"
          onClick={handlePrint}
          siteActivityProps={{
            core: {
              component: printComponent,
              elementId: 'print_click',
              coreClickData: {
                linkText: t('print')
              }
            }
          }}
        >
          <span className="ds-u-display--flex ds-u-flex-direction--column ds-u-justify-content--center">
            <IconPrint className="ds-u-color--base" aria-hidden />
            <span className="my-u-m--0 ds-u-font-size--sm ds-u-text-decoration--none">
              {t('print')}
            </span>
          </span>
        </Button>
      )
    }
  }, [printComponent, t])

  return (
    <>
      {nav}
      <main
        className={classNames(
          'my-u-content-minheight',
          'ds-base',
          'my-u-px--4',
          className
        )}
      >
        <div className="ds-l-container">
          <div
            className={
              'ds-l-row my-u-pt--0  my-u-my--20 ds-u-margin-bottom--4' +
              (width === 'wide' ? '' : ' ds-u-justify-content--center')
            }
          >
            <div
              className={
                width === 'default'
                  ? 'ds-l-col--12 ds-l-md-col--10 ds-l-lg-col--8'
                  : 'ds-l-col--12'
              }
            >
              <div className="ds-u-display--flex ds-u-justify-content--between">
                <h1
                  className="ds-text-heading--3xl ds-u-margin-bottom--2"
                  id={mainHeadingId}
                  tabIndex={-1}
                >
                  {heading}
                </h1>
                {withPrintButton && <WithPrintButton />}
              </div>

              {description && <div className="">{description}</div>}

            </div>
          </div>
        </div>
        {children}
      </main>
    </>
  )
}
